import { forwardRef, type ReactNode } from 'react';
import styled from 'styled-components';
import type { ScrollSnapAutoplay } from 'scroll-snap-slider';
import useScrollSnapSliderContext from './hooks/useScrollSnapSliderContext';

const Slider = styled.div`
    display: flex;
    flex-wrap: nowrap;
    overflow-y: hidden;
    overflow-x: auto;
    scroll-behavior: smooth;
    scroll-snap-stop: always;
    scroll-snap-type: x mandatory;

    & > * {
        scroll-snap-align: start;
    }
`;

const ScrollSnapSlider = forwardRef<HTMLDivElement, { children: ReactNode; pauseOnHover?: boolean }>(
    ({ children, pauseOnHover, ...restProps }, ref) => {
        const slider = useScrollSnapSliderContext();

        function pauseAutoplay(enable: boolean) {
            if (!pauseOnHover) return;

            if (enable) {
                (slider?.plugins.get('ScrollSnapAutoplay') as ScrollSnapAutoplay)?.enable();
            } else {
                (slider?.plugins.get('ScrollSnapAutoplay') as ScrollSnapAutoplay)?.disable();
            }
        }

        return (
            <Slider
                ref={ref}
                {...restProps}
                onMouseEnter={() => pauseAutoplay(false)}
                onMouseLeave={() => pauseAutoplay(true)}
            >
                {children}
            </Slider>
        );
    }
);

export default ScrollSnapSlider;
